import MarkerWithInfoWindows from "../../../../../../components/reports/report-map-utils/marker-with-info-windows.jsx";
import {useSpiderfy} from "../../../../../../hooks/use-spiderfier-adv-marker.js";
import {Polyline, useMap} from "@vis.gl/react-google-maps";
import {useEffect, useRef, useState} from "react";
import GenerateForm from "./generate-form.jsx";
import MapButtonsControl from "../../../../../../components/map-report/map-buttons-control.jsx";


const MapContent = ({data, mapState, setMapState}) => {
  const [activeId, setActiveId] = useState(null);
  const map = useMap();
  const [justOneTime, setJustOneTime] = useState(false);
  const filteredData = data.filter(el => (el.latitude && el.longitude))
  const { markers, toggleSpiderfy,  setSpiderState } = useSpiderfy(filteredData,map);

  useEffect(() => {
    if (!map) return;

    const listener = map.addListener("click", () => {
      setSpiderState(null);
      setActiveId(null);
    });

    return () => listener.remove();
  }, [map]);
  const handleClick = (item) => {
    const result = toggleSpiderfy(item);

    if (result?.type === "single") {
      setActiveId(item.id);
    }

    if (result?.type === "spiderfy") {
      setActiveId(null);
    }

    if (result?.type === "select") {
      setActiveId(item.id);
    }
  };

  useEffect(() => {
    if (!map || !markers?.length || justOneTime) return;

    setJustOneTime(true)

    const bounds = new google.maps.LatLngBounds();

    markers.forEach(item => {
      const lat = parseFloat(item.latitude ?? item.lat);
      const lng = parseFloat(item.longitude ?? item.lng);

      if (isNaN(lat) || isNaN(lng)) return;

      bounds.extend({ lat, lng });
    });

    if (!bounds.isEmpty()) {
      map.fitBounds(bounds);
    }

  }, [map, markers]);

  return (
    <>
      <MapButtonsControl
        mapState={mapState}
        onTogglePOI={() => setMapState(p => ({ ...p, pointsOfInterest: !p.pointsOfInterest }))}
        onToggleNeighborhood={() => setMapState(p => ({ ...p, neighborhoodStreets: !p.neighborhoodStreets }))}
        usesMapId={true}
      />
      {markers.map(el => (
        <MarkerWithInfoWindows key={`marker-${el.id}`} data={el} onClick={handleClick} isOpen={activeId === el.id} infoWindowContent={GenerateForm(el, setActiveId)}/>
      ))}
      {markers.map(el => {
        if (!el.original) return null;

        return (
          <Polyline
            key={`line-${el.id}`}
            path={[
              el.original,
              { lat: el.lat, lng: el.lng }
            ]}
            strokeColor="#000"
            strokeOpacity={0.7}
            strokeWeight={2}
          />
        );
      })}
    </>
  );
};

export default MapContent;